// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/documenti-societari?societaId=',
    requestBody: null,
    response: '{"success":true,"data":[...]}'
  },
  {
    method: 'POST',
    endpoint: '/api/documenti-societari',
    requestBody: 'FormData{societaId,tipo,descrizione,file}',
    response: '{"success":true,"id":"number"}'
  },
  {
    method: 'GET',
    endpoint: '/api/documenti-societari/versioni/:id/view',
    requestBody: null,
    response: 'file stream (inline)'
  },
  {
    method: 'PUT',
    endpoint: '/api/documenti-societari/:id',
    requestBody: '{"tipo":"string","descrizione":"string"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/documenti-societari/:id/file',
    requestBody: 'FormData{file}',
    response: '{"success":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/documenti-societari/:id',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
